import { render } from "./TypeFilter.vue?vue&type=template&id=afd5fd78&scoped=true"
import script from "./TypeFilter.vue?vue&type=script&lang=js"
export * from "./TypeFilter.vue?vue&type=script&lang=js"

import "./TypeFilter.vue?vue&type=style&index=0&id=afd5fd78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afd5fd78"]])

export default __exports__